import { Dropdown } from "semantic-ui-react";

/* ── Guest House Dropdown ── */
export default function GuestHouseDropdown({
  value,
  onChange,
  options,
  disabled = false,
}) {
  return (
    <Dropdown
      selection
      icon="chevron down"
      placeholder="All Guest Houses"
      disabled={disabled}
      value={value}
      onChange={(_, data) => onChange(data.value)}
      options={options.map((o) => ({ key: o.value, value: o.value, text: o.label }))}
    />
  );
}
